var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testing__started"},[(_vm.test && _vm.test.QuestionResults && _vm.test.QuestionResults.length)?_vm._l((_vm.test.QuestionResults),function(item,index){return _c('testing-item',{key:index,attrs:{"question":item,"is-done":_vm.isDone}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }